import React from 'react';
// logo
import LogoWhite from '../assets/img/logo_white.png';

const Footer = () => {
  return (
    <footer className='bg-primary'>
      <div className='container mx-auto text-white flex justify-between items-center'>
        {/* logo */}
        <a href='/'>
          <img src={LogoWhite} alt='logo' className='h-36 '/>
        </a>
        Copyright &copy; 2025 Copernicus House
      </div>
    </footer>
  );
};

export default Footer;
